import {writable} from "svelte/store";

export const jobByUUID = writable({});
export const jobsByStep = writable([]);
